<template>
	<b-row class="px-3">
		<b-button-group size="sm" class="mb-3">
			<b-button
				:class="
					(chartType === 'bar' ? 'td-btn-teal' : 'td-btn-outline-teal') +
					' mr-1'
				"
				pill
				@click="setChartType('bar')"
			>
				<b-icon icon="bar-chart-line-fill" /> Bar Chart
			</b-button>

			<b-button
				:class="
					(chartType === 'pyramid' ? 'td-btn-teal' : 'td-btn-outline-teal') +
					' mr-1'
				"
				pill
				@click="setChartType('pyramid')"
			>
				<b-icon icon="cone" /> Pyramid Chart
			</b-button>

			<b-button
				:class="
					(chartType === 'cylinder' ? 'td-btn-teal' : 'td-btn-outline-teal') +
					' mr-1'
				"
				pill
				@click="setChartType('cylinder')"
			>
				<b-icon icon="server" /> Cylinder Chart
			</b-button>

			<b-button
				:class="
					(chartType === 'pie' ? 'td-btn-teal' : 'td-btn-outline-teal') +
					' mr-1'
				"
				pill
				@click="setChartType('pie')"
			>
				<b-icon icon="pie-chart-fill" rotate="0"></b-icon> Pie Chart
			</b-button>

			<b-button
				:class="
					(chartType === 'area' ? 'td-btn-teal' : 'td-btn-outline-teal') +
					' mr-1'
				"
				pill
				@click="setChartType('area')"
			>
				<i class="fa fa-area-chart"></i> Area Chart
			</b-button>

			<b-button
				:class="
					(chartType === 'line' ? 'td-btn-teal' : 'td-btn-outline-teal') +
					' mr-1'
				"
				pill
				@click="setChartType('line')"
			>
				<b-icon icon="graph-up" /> Line Chart
			</b-button>

			<b-button
				:class="chartType === 'scatter' ? 'td-btn-teal' : 'td-btn-outline-teal'"
				pill
				@click="setChartType('scatter')"
				disabled
				title="under construction"
			>
				<b-iconstack class="mr-2" scale="1">
					<b-icon icon="dot" stacked shift-v="-5"></b-icon>
					<b-icon icon="dot" stacked shift-v="4" shift-h="3"></b-icon>
					<b-icon icon="dot" stacked shift-v="-1" shift-h="9"></b-icon>
					<b-icon icon="dot" stacked shift-v="11" shift-h="9"></b-icon>
					<b-icon icon="dot" stacked shift-v="5" shift-h="14"></b-icon>
				</b-iconstack>
				Scatter Chart
			</b-button>
		</b-button-group>
	</b-row>
</template>

<!-- javascript section-->
<script>
//import js modules section

// import WebWorkerApi from "../../../../../../../webworkers/tabel-dinamis/WebWorkerApi.js";

//local registration for output component
export default {
	name: "VisualizationChartMenuBar",
	data() {
		return {};
	},
	props: ["chartType", "setChartType"],
	created() {},
	destroyed() {},
	mounted() {},
	computed: {},
	watch: {},
	methods: {},
	components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";
</style>

<!-- author: m.	nif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 23-09-2022 -->
